import {
  BEGIN_FETCH_SPONSORED_PRODUCTS,
  BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS,
  FETCH_SPONSORED_PRODUCTS_ERROR,
  FETCH_SPONSORED_PRODUCTS_SUCCESS,
  FETCH_SYMPHONY_SEARCH_COMPONENTS_ERROR,
  RECEIVE_SYMPHONY_SEARCH_COMPONENTS
} from 'store/ducks/search/types';

const initialState = {
  isLoadingSponsoredProducts: false,
  sponsoredProducts: {},
  error: null,
  isLoadingSymphony: false,
  symphony: {}
};

export default function searchReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case BEGIN_FETCH_SPONSORED_PRODUCTS:
      return { ...state, isLoadingSponsoredProducts: true };
    case FETCH_SPONSORED_PRODUCTS_SUCCESS:
      return { ...state, isLoadingSponsoredProducts: false, sponsoredProducts: payload.sponsoredProducts };
    case FETCH_SPONSORED_PRODUCTS_ERROR:
      return { ...state, isLoadingSponsoredProducts: false, error: payload.error };
    case BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS:
      return { ...state, isLoadingSymphony: true };
    case RECEIVE_SYMPHONY_SEARCH_COMPONENTS:
      return { ...state, isLoadingSymphony: false, symphony: payload.data };
    case FETCH_SYMPHONY_SEARCH_COMPONENTS_ERROR:
      return { ...state, isLoadingSymphony: false, error: payload.error };
    default:
      return state;
  }
}
